// ▼アコーディオンメニュー
window.addEventListener("DOMContentLoaded", function () {
  const accordionContent = document.querySelectorAll(".aim-list li");
  const swiperAccordionContent = document.querySelectorAll(".js-wrap");
  const mediaQuery = window.matchMedia("(max-width: 750px)");

  if (mediaQuery.matches) {
    swiperAccordionContent.forEach((items) => {
      let title = items.querySelector(".js-nav-trigger");
      title.addEventListener("click", () => {
        items.classList.toggle("is-nav-active");

        let content = items.querySelector(".pickup");
        if (items.classList.contains("is-nav-active")) {
          content.style.height = `${content.scrollHeight}px`;
          content.style.visibility = "visible";
        } else {
          content.style.height = "0px";
          content.style.visibility = "hidden";
        }
      });
    });

    accordionContent.forEach((item, index) => {
      let header = item.querySelector(".js-nav-trigger");
      header.addEventListener("click", (e) => {
        item.classList.toggle("is-nav-active");

        let description = item.querySelector(".list-text");
        if (item.classList.contains("is-nav-active")) {
          description.style.height = `${description.scrollHeight}px`;
          description.style.margin = `2rem 0`;
          description.style.visibility = "visible";
        } else {
          description.style.height = "0px";
          description.style.margin = `0`;
          description.style.visibility = "hidden";
        }
      });
    });
  }
});
